import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { AppService } from '../../../app.service';
import { LoadingService } from '../../../shared/services/loading.service';
import { TranslateService } from '../../../translate';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FormBuilder, FormControl } from '@angular/forms';
import { SetupEquipmentService } from '../setup-equipment.service';
import { CustomerSelectItem, JobsiteSelectItem, EquipmentSelectItem, Equipment, ApplicationSelectedItem, FamilySelectItem } from '../setup-equipment.model';
import { NotificationsService } from 'angular2-notifications';
import { Location } from '@angular/common';
import { forkJoin } from "rxjs/observable/forkJoin";
import moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { RequestNewModelPopupComponent } from '../request-new-model-popup/request-new-model-popup.component';
import { AppUris } from '../../../entities/app-config/model';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { PreferencesService } from '../../preferences/preferences.service';



@Component({
  selector: 'setup-equipment',
  templateUrl: './setup-equipment.component.html',
  styleUrls: ['./setup-equipment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger(
      'fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 0 }),
        animate('0ms', style({ opacity: 0 }))
      ])
    ]
    )],
  providers: [

    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    //{ provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
})
export class SetupEquipmentComponent implements OnInit {
  private _userLanguage: string = "english";
  private _subscriptions: Subscription[] = [];
  private _equipmentId: number;
  setupComplete: boolean = false;
  //newOrExistingOption: string = "1";
  newOrExistingOption: number | null = null;
  isLinear = true;
  currentStep: number = 0;
  unsyncedId: number = 0;
  // Existing Equipment
  existingEquipment: Equipment;
  loadingExistingEquipment: boolean = false;
  updatingEquipment: boolean = false;
  canChangeHoursAndDate: boolean = true; // If the user is editing an equipment that has inspections, this should be false.

  // Step 1
  customerList: CustomerSelectItem[] = [];
  customerListFilter : CustomerSelectItem[] = [];
  jobsiteList: JobsiteSelectItem[] = [];
  jobsiteListFilter: JobsiteSelectItem[] = [];
  equipmentList: EquipmentSelectItem[] = [];

  selectedCustomer: number;
  selectedJobsite: number;
  selectedEquipment: number;

  appUris: AppUris;

  // Step 2
  makeList: JobsiteSelectItem[] = [];
  makeListFilter : JobsiteSelectItem[] = [];
  modelList: JobsiteSelectItem[] = [];

  modelListFilter: JobsiteSelectItem[] = [];
  selectedFamily: FamilySelectItem;

  customerName: string = '';
  jobsiteName: string = '';
  makeName: string = '';
  familyName: string = '';
  familyId: number = 0;
  serialNumber: string = '';
  unitNumber: string = '';
  selectedMake: number;
  selectedModel: number;
  smuAtSetup: number = 0;
  ltdAtSetup: number = 0;
  pmuAtSetup: number = 0;
  dateOfReading: Date = new Date();
  imageUrl: string = '';
  serialUnitValid: boolean = true;
  isValidating: boolean = true;
  smuLtdGreaterThanZero: boolean = true;
  pmuGreaterThanZero: boolean = true;
  smuGreaterThanPmu: boolean = true;
  ltdGreaterThanSmu: boolean = true;
  additionalUnitNo: string = '';
  // Step 3
  rankingList: CustomerSelectItem[] = [];
  applicationList: ApplicationSelectedItem[] = [];
  InspectionCount: number = 0;
  statusList = [
    { Id: 0, Name: 'Not in Use' },
    { Id: 1, Name: 'In Use' },
    { Id: 2, Name: 'Parked' },
    { Id: 3, Name: 'Rental' },
    { Id: 4, Name: 'Single Inspection' }
  ];
  unitList = [
    { Id: 0, Name: 'Hours' },
    { Id: 1, Name: 'Days' }
  ]

  forecastingList = [
    { Id: 0, Name: 'Off' },
    { Id: 1, Name: 'On' }
  ];
  selectedApplication: number = 0;
  selectedRanking: number;
  selectedStatus: number = 1;
  selectedInspectEveryUnit: number = 0;
  inspectEvery: number = 500;
  hoursUsePerDay: number = 16;
  monCheck: boolean = true;
  tueCheck: boolean = true;
  wedCheck: boolean = true;
  thuCheck: boolean = true;
  friCheck: boolean = true;
  satCheck: boolean = false;
  sunCheck: boolean = false;
  creatingEquipment: boolean = false;
  selectedForecast: number = 0;
  bcmAtSetup: number;
  tonAtSetup: number;
  dateOfReadingControl = new FormControl(moment());
  useBackdate: string
  isRSH: boolean = false;
  UCSetupType: number = 1;
  enableDistTravelledTracking: boolean = false;
  showDistTravelledTracking: boolean = false;
  public todate = new Date();
  distanceForward: number = 0;
  distanceReverse: number = 0;
  distanceForwardatSetup: number = 0;
  distanceReverseatSetup: number = 0;
  AvgDistance:number=20;
    userUOD: string = 'km'; 
  constructor(
    private _dialog: MatDialog,
    private _translate: TranslateService,
    private _ref: ChangeDetectorRef,
    private _route: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _equipmentService: SetupEquipmentService,
    private _notification: NotificationsService,
    private _appService: AppService,
    private _loading: LoadingService,
    private _router: Router,
    private _location: Location,
  private readonly _pref: PreferencesService) { }

  ngOnInit() {
    this.newOrExistingOption=1;
    this.dateOfReading.setMonth(this.dateOfReading.getMonth() - 3);
    this._loading.startLoading();
    this._appService.setPageTitle('Setup Equipment');
    this._appService.getAppUris().subscribe(result => { this.appUris = result; });
    this._appService.GetDeafultUCSetupType().subscribe((res:any) => {
      this.UCSetupType = res;
    })
  this.getUserUOD(); 

    this._subscriptions.push(this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2)));
    if (this._route.snapshot.params.id > 0)
      this._equipmentId = this._route.snapshot.params.id;
    this._route.queryParams.subscribe((params: Params) => {
      let _unsyncedId = params['unsyncedid'];
      if (_unsyncedId) {
        this._appService.getApplicationConfigValue("BackDateUnsyncedEqSetup").subscribe(result => {
          this.useBackdate = result
        });

        this.unsyncedId = this._appService.simpleNumberDecrypt(_unsyncedId);
        this._equipmentService.getUnsyncEquipmentInfo(this.unsyncedId).subscribe(r => {
          //console.log("Result", r)
          if (this.useBackdate == "1") {
            // if(r.Smu!=null){
            //   if(r.Smu>=500){
            //     this.smuAtSetup = r.Smu -500;
            //   }else{
            //     this.smuAtSetup = 0;
            //   }
            // }
            // if(r.LTD!=null){
            //   console.log("Result", r.LTD)
            //   if(r.LTD>=500){
            //     this.ltdAtSetup = r.LTD -500;
            //   }else{
            //     this.ltdAtSetup = 0;
            //   }
            // }
            this.smuAtSetup = (r.Smu >= 500) ? (r.Smu - 500) : 0;
            this.ltdAtSetup = (r.LTD >= 500) ? (r.LTD - 500) : 0;


          } else {
            this.smuAtSetup = r.Smu;
            this.ltdAtSetup = r.LTD;
            this.dateOfReading = new Date();
          }
          this.serialNumber = r.SerialNumber;
          this.unitNumber = r.UnitNumber;

          this.loadCustomerAndJobsites(r.CustomerId, r.JobsiteIdCRSF);
          var selectedCust = this.customerList.find(c => c.Id == r.CustomerId);
          if (selectedCust != undefined)
            this.selectedCustomer = selectedCust.Id;
          var selectedJob = this.jobsiteList.find(j => j.Id == r.JobsiteIdCRSF);
          if (selectedJob != undefined)
            this.selectedJobsite = selectedJob.Id;
        });

      } else
        this.dateOfReading = new Date();
    }, error => console.error(error), () => { });
    this._loading.finishedLoading();
    if (this._equipmentId != null) // If an equipment id has been passed in through the URL
      this.loadExistingEquipment();
    else // If theere is no equipment id being passed in
      this.loadStepOne();
  }
 getUserUOD(){
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOD = res.UnitofDistance;
    })
  }
  loadCustomerAndJobsites(routeCustomerId, routeJobsiteIdCRSF) {
    let customers = this._equipmentService.getCustomerList();
    let jobsites = this._equipmentService.getJobsiteList(routeCustomerId);

    this._subscriptions.push(forkJoin([customers, jobsites]).subscribe(r => {
      this.customerList = r[0];
      this.customerListFilter = r[0];
      this.jobsiteList = r[1];
      this.jobsiteListFilter = r[1];
      this.setRouteCustomerAndJobsite(routeCustomerId, routeJobsiteIdCRSF);
    }));
  }

  setRouteCustomerAndJobsite(routeCustomerId, routeJobsiteIdCRSF) {
    var selectedCust = this.customerList.find(c => c.Id == routeCustomerId);
    if (selectedCust != undefined)
      this.selectedCustomer = selectedCust.Id;
    var selectedJob = this.jobsiteList.find(j => j.Id == routeJobsiteIdCRSF);
    if (selectedJob != undefined)
      this.selectedJobsite = selectedJob.Id;
  }

  clearInputs() {
    this.familyName = '';
    this.serialNumber = '';
    this.unitNumber = '';
    this.selectedMake = -1;
    this.selectedModel = -1;
    this.machineModel = '';
    this.smuAtSetup = 0;
    this.ltdAtSetup = 0;
    this.pmuAtSetup = 0;
    this.dateOfReading = new Date();
    this.imageUrl = '';
    this.serialUnitValid = true;
    this.isValidating = true;
    this.selectedFamily = null;
    this.selectedApplication = -1;
    this.selectedRanking = -1;
    this.selectedStatus = 1;
    this.selectedForecast = 0;
    this.selectedInspectEveryUnit = 0;
    this.inspectEvery = 500;
    this.hoursUsePerDay = 16;
    this.AvgDistance=20;
    this.monCheck = true;
    this.tueCheck = true;
    this.wedCheck = true;
    this.thuCheck = true;
    this.friCheck = true;
    this.satCheck = false;
    this.sunCheck = false;
    this.canChangeHoursAndDate = true;
    this.creatingEquipment = false;
    this.additionalUnitNo = '';
    this.distanceForward = 0;
    this.distanceReverse = 0;
    this.distanceForwardatSetup = 0;
    this.distanceReverseatSetup = 0;
  }

  // TT-1319
  openAddNewJobsite() {
    //window.open(this.appUris.IdentityServerUri + 'administration');
    window.open('/administrator', '_blank');
  }

  loadExistingEquipment() {
    this.loadingExistingEquipment = true;
    this._subscriptions.push(this._equipmentService.getEquipmentSetupDetails(this._equipmentId).subscribe(equipment => {
      console.log("equ", equipment)
      if (equipment.Photo == "") {
        equipment.Photo = "iVBORw0KGgoAAAANSUhEUgAAAHgAAABOCAIAAABkJUU1AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMTZEaa/1AAAFN0lEQVR4Xu2c2VYiMRRF/f//sx1abWdEcBabx95w0rWKqlRRQyYg+4FlgKWyc+omuaBHk8nk4+NjuVz+zfjh/f396enpiK9eXl6m0+lisdADGVegFLGvr6/keCVad2Ed9xpmxoNfLP/8/GhoRIu3tzce+/7+NuPMIL6+vtBIQTbjNRuiQWnHuBln+kB+qcOz2awIckFVtGA20M3MmHGmA5+fn5Rfbs14E7toYE6YGQpNfXIyFVA0X9PiqlG0YH5ytNtRkLcq2iIaukzXYYIQLnqKchcz20WL9gJ0gHQMckFX0cC8NS2pB0WvIBf0EC20STzYaHOmG7Zo9RYtKNmHFm1e7PPzM0E2454MFA3MKkWqcv7ZVxTkMWfm4aIFM8w873G0XR2Vx4oG5plo72VDqtIYGoMD0YI5J9p702slPSh2mB5noqFov5rxzuKjHroULQZvgFLA3wrvXjQUO6EdWiT5Vb0u7F5Ei76H1IgEaDB4FA2kg3NNyg2pYL+hX9GCpKRZtUO+vxFCNJCXVad1Pjfj2CjIIVeRQKKFou21FHYhyr4oqGhQlMCMw8JP13bIjAMSWrTQKh+4ITW+MTSGOKKF9q0BTu0pHFljiobuvbFlA+bhZvSpoGCLXhORRQs1pAoXRmFJIvNxdXX1u8bFxUXLmqbG0PgOpxOSEA1YxiZyMf7nP0URp6D/auD29lbPKcN383qeHkAqogWiHx4ejo+PMXh6eqouJRNwdnYmrXVOTk4qoUYuu5rU3vpJTjQxnEwmKC7CyNBIXYNZMIM1d3d3PNmKvkMKpCW6AEe4RjGlWVq5pUqwcyC/QOW9v78n9XLNF3V4frnQxyUh0cjleqccU52pFeXYsu5VSoEMYpyZME+qcX19nUVbYIdgDG2CZYTyBG6p4JeXl2w2KBdSz/Q0uc6i7ZBlLYMVdNDgtrIkEnkKOg9xzqxUbZFF27GKJr88RJatGw/8Ktc3NzfmrhJZtB2raO5E1uPjoxnXQDFPYNdsxiWyaDtW0aobLSve+fk5TyDXZlwii7bTIpoCYsY1JJoybcYlsmg7VtFsRZDFltmMa7AXzKWjH1bRFA0eIrAcQMxdm6hnxNnEjEtk0XasotlXSOVsNqvv4VgkUZm3d/2wigYOLHpbhBWPPQZFGUi6yjcHlqYKnkXbaRINuFYnrwL765Z1Mou20yIaKA6IY9GjUABx5hTeVLhFFm2nXXQBxq0VuU4WXYWELhYLlju9O+UKNoVZtIGlDL9eP8HEEprCJ6RiikYB5YI4m7E3+BH8IPVaYxFHNEF+DvuJIV06YMbBiSCajVqsfCnaAa6hOkFFs+IRZB00IkLJJtpk3IyDEE40J+lpMv8iS3+ypzcNwhBCNHLT+cRQGa4trrAwc+9dNC8Gy4Gv0+4EC4FH0bo8rT2K1FBZ8/qJXi+iyW9qH33biu+F2r1o9m2xtlDj0RnKR7Rdiia/q78H2vH/vsQvz+aPK9Ltq3AmmghT5nY0yHWINi/H4anKgWhFYNeDXIeq7TDaY0UHawzFQi9wfLSHi2aeWaYJshnvL8Ula8aDGCja1TzvEFy1Y67d3qIV5JAdzqQg18MaUv1Eq8Pp9QSVPjoo9D3xdhWNXLY70Tuc6aAeTveGVCfRagU42eXsE1gm2h0bUltEK8g70RiKhVK4NdqNoskvK96wwn9oYBnX7dG2i97pxlAsuO7R3bRTqIomv4N3MBmi3dRr3RA9ck+eEdaGlBGtIEMOshOIthpSZizROcieKDcqjsa3SzItUCFWhufzf5LmIP5DdRB8AAAAAElFTkSuQmCC";
      }
      this.newOrExistingOption = 2;
      let customers = this._equipmentService.getCustomerList();
      let jobsites = this._equipmentService.getJobsiteList(equipment.CustomerId);
      let equipmentList = this._equipmentService.getEquipmentList(equipment.JobsiteId);
      let makeList = this._equipmentService.getOEMMakeList();
      let modelList = this._equipmentService.getModelList(equipment.MakeId);
      let familyName = this._equipmentService.getFamilyNameForModel(equipment.ModelId);
      let applicationList = this._equipmentService.getEquipmentApplicationList();
      let rankingList = this._equipmentService.getEquipmentRankingList();
      this.GetInspectionCount();
      if (equipment.CanChangeSmuLtd)
        this.canChangeHoursAndDate = true;
      else
        this.canChangeHoursAndDate = false;
      this._subscriptions.push(forkJoin([customers, jobsites, equipmentList, makeList, modelList, familyName, applicationList, rankingList]).subscribe((r:any) => {
        this.customerList = r[0];
        this.customerListFilter = r[0];
        this.jobsiteList = r[1];
        this.jobsiteListFilter = r[1];
        this.equipmentList = r[2];
        this.makeList = r[3];
        this.makeListFilter = r[3];
        this.modelList = r[4];
        //this.familyName = r[5];
        this.applicationList = r[6];
        this.rankingList = r[7];
        this.selectedFamily = r[5];
        this.selectedCustomer = equipment.CustomerId;
        this.selectedJobsite = equipment.JobsiteId;
        this.selectedEquipment = equipment.Id;
        this.selectedMake = equipment.MakeId;
        this.selectedModel = equipment.ModelId;

        let mName = this.modelList.find(f => f.Id == equipment.ModelId).Name
        this.machineModel = mName;
        let custName = this.customerList.find(f => f.Id == equipment.CustomerId).Name;
        this.customerName = custName;
        let siteName = this.jobsiteList.find(f => f.Id == equipment.JobsiteId).Name;
        this.jobsiteName = siteName;
        let maName = this.makeList.find(f => f.Id == equipment.MakeId).Name;
        this.makeName = maName;

        this.selectedForecast = equipment.ForecastId;
        this.selectedApplication = equipment.ApplicationId;
        this.selectedRanking = equipment.RankingId;
        this.dateOfReading = new Date(equipment.Date);
        this.hoursUsePerDay = equipment.HoursOfUsePerDay;
        this.AvgDistance=equipment.AvgDistance;
        this.inspectEvery = equipment.InspectEvery;
        this.selectedInspectEveryUnit = equipment.InspectEveryUnitTypeId;
        this.ltdAtSetup = equipment.Ltd;
        this.pmuAtSetup = equipment.Pmu;
        this.serialNumber = equipment.SerialNumber;
        this.smuAtSetup = equipment.Smu;
        this.unitNumber = equipment.UnitNumber;
        this.monCheck = equipment.UsedMonday;
        this.tueCheck = equipment.UsedTuesday;
        this.wedCheck = equipment.UsedWednesday;
        this.thuCheck = equipment.UsedThursday;
        this.friCheck = equipment.UsedFriday;
        this.satCheck = equipment.UsedSaturday;
        this.sunCheck = equipment.UsedSunday;
        this.selectedStatus = equipment.StatusId;
        // this.newOrExistingOption = '2';
        this.serialUnitValid = true;
        this.isValidating = false;
        this.imageUrl = 'data:image/png;base64,' + equipment.Photo;
        this.loadingExistingEquipment = false;
        this.additionalUnitNo = equipment.AdditionalUnitNo;
        this.familyName = this.selectedFamily.Name;
        if (equipment.Ton == -1)
          this.tonAtSetup = undefined
        else
          this.tonAtSetup = equipment.Ton;
        if (equipment.Bcm == -1)
          this.bcmAtSetup = undefined
        else
          this.bcmAtSetup = equipment.Bcm;
        this.enableDistTravelledTracking = equipment.EnableDistTravelledTracking;
        this.distanceForward = equipment.DistanceForward;
        this.distanceReverse = equipment.DistanceReverse;
        this.distanceForwardatSetup = equipment.DistanceForwardatSetup;
        this.distanceReverseatSetup = equipment.DistanceReverseatSetup;
        //if(this.selectedFamily.Id==177 || this.selectedFamily.Id==203){
        if (equipment.ShowPropelHrsPerc) {
          this.isRSH = true;
        } else {
          this.isRSH = false;
        }
      }));
    }));
    this.showDistTravelledTrackingForFamily(this._equipmentId, 0);
    this.newOrExistingOption = 2;
  }

  GetInspectionCount() {
this._equipmentService.GetEquipmentInspectionCount(this._equipmentId).subscribe(res => {
  if(res != null)
      this.InspectionCount = res;
    });
}

  onSelectEquipment() {
    if (this.selectedEquipment != null) {
      this._equipmentId = this.selectedEquipment;
      //this._router.navigate(['setup-equipment', this.selectedEquipment]);
      if (this.unsyncedId > 0)
        this._location.go('setup-equipment/' + this.selectedEquipment + '/?unsyncedId=' + this._appService.simpleNumberEncrypt(this.unsyncedId));
      else
        this._location.go('setup-equipment/' + this.selectedEquipment);
      this.clearInputs();
      this.loadExistingEquipment();
    }
  }

  onNewEquipment() {
    if (this.unsyncedId > 0)
      this._location.go('setup-equipment/' + '?unsyncedid=' + this._appService.simpleNumberEncrypt(this.unsyncedId));
    else
      this._router.navigate(['setup-equipment']);
    this.clearInputs();
  }

  loadStepOne() {
    this._subscriptions.push(this._equipmentService.getCustomerList().subscribe(r => {
      this.customerList = r;
      this.customerListFilter = r;
    }));
  }

  navigateToSetupUndercarriage() {
    //this._loading.finishedLoading();
    this._router.navigate(['setup-undercarriage/on-equipment', this._equipmentId]);
  }
  navigateToUnsyncedInspection() {
    this._router.navigate(['unsyncedinspection/', this.unsyncedId]);
  }
  navigateToSetupNewEquipment() {
    this._router.navigate(['setup-equipment']);
    this._equipmentId = null;
    this.setupComplete = false;
    this.newOrExistingOption = 1;
    this.currentStep = 0;
    this.clearInputs();
    this._subscriptions.push(this._equipmentService.getEquipmentList(this.selectedJobsite).subscribe(equipmentList => {
      this.equipmentList = equipmentList;
    }));
  }

  navigateToManageEquipment() {
    this._router.navigate(['equipment', this._equipmentId]);
  }

  validateSerialAndUnit() {
    if (this.serialNumber != null && this.unitNumber != null && this.serialNumber != '' && this.unitNumber != '') {
      this.isValidating = true;
      this._loading.startLoading();
      this._subscriptions.push(this._equipmentService.validateEquipmentSerialAndUnitDealerGroup(this.selectedJobsite, this.selectedCustomer, this.serialNumber, this.unitNumber, this._equipmentId != null ? this._equipmentId : 0).subscribe(r => {
        this.serialUnitValid = r;
        this.isValidating = false;
        this._loading.finishedLoading();
      }));
    }

  }



  validateSmuAndLtd() {
    if (this.smuAtSetup < 0 || this.ltdAtSetup < 0)
      this.smuLtdGreaterThanZero = false;
    else
      this.smuLtdGreaterThanZero = true;

    if (this.smuAtSetup > this.ltdAtSetup) {
      this.ltdAtSetup = this.smuAtSetup
    }
    // this.ltdGreaterThanSmu = false;
    else this.ltdGreaterThanSmu = true;
  }

  validateSmuAndPmu() {
    if (this.smuAtSetup < 0 || this.pmuAtSetup < 0)
      this.pmuGreaterThanZero = false;
    else
      this.pmuGreaterThanZero = true;

    if (this.pmuAtSetup > this.smuAtSetup)
      this.smuGreaterThanPmu = false;
    else this.smuGreaterThanPmu = true;
  }
  selected: number;
  
  onCustomerSelected(event: any) {
    const customer = this.customerList.find(x => x.Name === event.value);
    if (customer) {
      this.selectedCustomer = customer.Id;
      this.customerName = customer.Name;
    }
    this.loadJobsitesForCustomer();
  }

  changedCustomer(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this.customerList = this.customerListFilter.filter(x => x.Name.toLowerCase().includes(filterValue));
    } else {
      this.resetCustomer();
    }
  }

  resetCustomer() {
    this.selectedCustomer = 0;
    this.customerList = this.customerListFilter;
    this.selectedJobsite = 0;
    this.jobsiteName = '';
    this.selectedEquipment = 0;
  }


 loadJobsitesForCustomer() {
    if (this.selectedCustomer == null)
      return;
    this._loading.startLoading();
    this.selectedJobsite = null;
    this.jobsiteList = [];
    this.selectedEquipment = null;
    this.equipmentList = [];
    this._subscriptions.push(this._equipmentService.getJobsiteList(this.selectedCustomer).subscribe(r => {
      this.jobsiteList = r;
      this.jobsiteListFilter = r;
      if (this.jobsiteList.length == 1) {
        this.selected = this.jobsiteList[0].Id;
        this.selectedJobsite = this.selected;
        this.jobsiteName = this.jobsiteList[0].Name;
        this.loadEquipmentForJobsite();
      } else {
        this.jobsiteName = '';
        this.selectedJobsite = 0;
        this.selectedEquipment = 0;
      }
      this._loading.finishedLoading();
    }));
  }

  onJobsiteSelected(event: any) {
    const jobsite = this.jobsiteList.find(x => x.Name === event.value);
    if (jobsite) {
      this.selectedJobsite = jobsite.Id;
      this.jobsiteName = jobsite.Name;
    }
    this.loadEquipmentForJobsite();
  }

  changedJobsite(event: any) {
    const value = event.target.value;
    if (value !== '') {
      const filterValue = value.toLowerCase();
      this.jobsiteList = this.jobsiteListFilter.filter(x => x.Name.toLowerCase().includes(filterValue));
    } else {
      this.resetJobsite();
    }
  }

  resetJobsite() {
    this.jobsiteName = '';
    this.selectedJobsite = 0;
    this.jobsiteList = this.jobsiteListFilter;
    this.selectedEquipment = 0;
  }


  loadEquipmentForJobsite() {
    if (this.selectedJobsite == null)
      return;
    this._loading.startLoading();
    this._subscriptions.push(this._equipmentService.getEquipmentList(this.selectedJobsite).subscribe(r => {
      this.equipmentList = r;
      this._loading.finishedLoading();
    }));
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => {
      if (!s.closed)
        s.unsubscribe();
    });
  }

  validateHoursOfUse() {
    if (this.hoursUsePerDay >= 0 && this.hoursUsePerDay <= 24) {
      return true;
    } else {
      return false;
    }
  }

  onUpdateEquipmentClick() {
    if (!this.stepTwoIsValid() || !this.stepThreeIsValid())
      return;
    if (!this.validateHoursOfUse()) {
      this._notification.error("Failed", "Hours per day must be between 0 and 24!");
      return;
    }
    this._loading.startLoading();
    this.updatingEquipment = true;

    let e = new Equipment();
    e.Id = this.selectedEquipment;
    e.ApplicationId = this.selectedApplication;
    e.CustomerId = this.selectedCustomer;
    e.Date = this.dateOfReading;
    e.HoursOfUsePerDay = this.hoursUsePerDay;
    e.AvgDistance= this.AvgDistance;
    e.InspectEvery = this.inspectEvery;
    e.InspectEveryUnitTypeId = this.selectedInspectEveryUnit;
    e.JobsiteId = this.selectedJobsite;
    e.Ltd = this.ltdAtSetup;
    e.Pmu = this.pmuAtSetup;
    e.MakeId = this.selectedMake;
    e.ModelId = this.selectedModel;
    e.Photo = this.imageUrl;
    e.RankingId = this.selectedRanking;
    e.SerialNumber = this.serialNumber;
    e.Smu = this.smuAtSetup;
    e.StatusId = this.selectedStatus;
    e.ForecastId = this.selectedForecast;
    e.UnitNumber = this.unitNumber;
    e.UsedMonday = this.monCheck;
    e.UsedTuesday = this.tueCheck;
    e.UsedWednesday = this.wedCheck;
    e.UsedThursday = this.thuCheck;
    e.UsedFriday = this.friCheck;
    e.UsedSaturday = this.satCheck;
    e.UsedSunday = this.sunCheck;
    e.UnsyncedId = this.unsyncedId;
    e.AdditionalUnitNo = this.additionalUnitNo;
    e.SetupDate = this.getFormatedDate(new Date(this.dateOfReading));
    e.EnableDistTravelledTracking = this.enableDistTravelledTracking;
    e.DistanceForward = this.distanceForwardatSetup;
    e.DistanceReverse = this.distanceReverseatSetup;
    if (this.bcmAtSetup == undefined)
      e.Bcm = -1;
    else
      e.Bcm = this.bcmAtSetup;
    if (this.tonAtSetup == undefined)
      e.Ton = -1;
    else
      e.Ton = this.tonAtSetup;

    this._subscriptions.push(this._equipmentService.updateEquipment(e).subscribe(r => {

      this.updatingEquipment = false;
      this._loading.finishedLoading();
      if (r.m_Item1 == -1) {
        this._notification.error('Failed', r.m_Item2);
      } else {
        //this._loading.finishedLoading();
        this._equipmentId = r.m_Item1;
        this.setupComplete = true;
        this._router.navigateByUrl('setup-undercarriage/on-equipment/' + this._equipmentId);
        //this._notification.success('Equipment Updated', 'Your equipment has been updated. ');
      }
    }, error => { this.creatingEquipment = false; this._loading.finishedLoading(); this._notification.error('Error', 'Failed to update the equipment. Please contact support. '); console.log(error); }));
  }

  getFormatedDate = (currentDate) => {

    console.log("curernt ", currentDate)
    let dd = currentDate.getDate();
    let mm = currentDate.getMonth() + 1; // January is 0!
    const yyyy = currentDate.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    return `${dd} ${mm} ${yyyy}`;
  };

  onCreateNewEquipmentClick_UCSYSTEMBasic() {
    this.loadingApplicationList();
    // this.loadRankingList();
  }
  onCreateNewEquipmentClick() {


    if (!this.stepTwoIsValid() || !this.stepThreeIsValid())
      return;
    if (!this.validateHoursOfUse()) {
      this._notification.error("Failed", "Hours per day must be between 0 and 24!");
      return;
    }

    this._loading.startLoading();
    this.creatingEquipment = true;
    let e = new Equipment();
    e.ApplicationId = this.selectedApplication;
    e.CustomerId = this.selectedCustomer;
    e.Date = this.dateOfReading;
    e.HoursOfUsePerDay = this.hoursUsePerDay;
    e.AvgDistance=this.AvgDistance
    e.InspectEvery = this.inspectEvery;
    e.InspectEveryUnitTypeId = this.selectedInspectEveryUnit;
    e.JobsiteId = this.selectedJobsite;
    e.Ltd = this.ltdAtSetup;
    e.Pmu = this.pmuAtSetup;
    e.MakeId = this.selectedMake;
    e.ModelId = this.selectedModel;
    e.Photo = this.imageUrl;
    e.RankingId = this.selectedRanking;
    e.SerialNumber = this.serialNumber;
    e.Smu = this.smuAtSetup;
    e.StatusId = this.selectedStatus;
    e.ForecastId = this.selectedForecast;
    e.UnitNumber = this.unitNumber;
    e.UsedMonday = this.monCheck;
    e.UsedTuesday = this.tueCheck;
    e.UsedWednesday = this.wedCheck;
    e.UsedThursday = this.thuCheck;
    e.UsedFriday = this.friCheck;
    e.UsedSaturday = this.satCheck;
    e.UsedSunday = this.sunCheck;
    e.UnsyncedId = this.unsyncedId;
    e.AdditionalUnitNo = this.additionalUnitNo;
    e.SetupDate = this.getFormatedDate(new Date(this.dateOfReading));
    e.EnableDistTravelledTracking = this.enableDistTravelledTracking;
    e.DistanceForward = this.distanceForwardatSetup;
    e.DistanceReverse = this.distanceReverseatSetup;
    if (this.bcmAtSetup == undefined)
      e.Bcm = -1;
    else
      e.Bcm = this.bcmAtSetup;
    if (this.tonAtSetup == undefined)
      e.Ton = -1;
    else
      e.Ton = this.tonAtSetup;

    this._subscriptions.push(this._equipmentService.createNewEquipment(e).subscribe(r => {

      this.creatingEquipment = false;
      this._loading.finishedLoading();
      if (r.m_Item1 == -1) {
        this._notification.error('Failed', r.m_Item2);
      } else {
        this._equipmentId = r.m_Item1;
        this.setupComplete = true;
        this._notification.success('Equipment Added', 'Your equipment has been added to the system successfully. Please setup the undercarriage for it. ');
      }
    }, error => { this.creatingEquipment = false; this._loading.finishedLoading(); this._notification.error('Error', 'Failed to create the equipment. Please contact support. '); console.log(error); }));
  }

  updateUserLang(lang: string) {
    this._userLanguage = lang;
    this._ref.detectChanges();
  }

  goToStep(step: number) {
    //console.log(step, this.selectedCustomer, this.selectedJobsite, this.selectedEquipment, this.newOrExistingOption);
    //console.log(step, this.serialNumber, this.unitNumber, this.selectedMake, this.selectedModel, this.smuAtSetup, this.ltdAtSetup);
    switch (step) {
      case 1:
        if (this.stepTwoIsValid()) {
          this.currentStep = 1;
          this.loadMakes();
          this.validateSerialAndUnit();
        }
        break;
      case 2:
        if (this.stepThreeIsValid()) {
          this.currentStep = 2;
          this.loadingApplicationList();
          this.loadRankingList();
        }
        break;
    }
  }

  stepTwoIsValid(): boolean {
    return (this.selectedCustomer > 0 && this.selectedJobsite > 0 && ((this.newOrExistingOption == 2 && this.selectedEquipment > 0) || this.newOrExistingOption == 1));

  }

  stepThreeIsValid(): boolean {
    return (this.smuLtdGreaterThanZero && this.ltdGreaterThanSmu && this.serialNumber != '' && this.unitNumber != '' && this.selectedMake > 0 && this.selectedModel > 0 && this.smuAtSetup >= 0 && this.ltdAtSetup >= 0 && this.serialUnitValid && !this.isValidating && !isNaN(new Date(this.dateOfReading).getTime()));
  }

  goBackStep(step: number) {
    this.currentStep--;
  }

  loadingApplicationList() {
    this._loading.startLoading();
    this._subscriptions.push(this._equipmentService.getEquipmentApplicationList().subscribe(r => {
      this.applicationList = r;
      if (this.selectedApplication <= 0) {
        this.selectedApplication = r[r.findIndex(i => i.Default == true)].Id;
      }


      this._loading.finishedLoading();

      if (this.UCSetupType != 1 && this.newOrExistingOption == 1) {
        this.loadRankingList();
      }
    }));
  }

  loadRankingList() {
    this._loading.startLoading();
    this._subscriptions.push(this._equipmentService.getEquipmentRankingList().subscribe(r => {
      this.rankingList = r;
      this._loading.finishedLoading();
      if (this.UCSetupType != 1 && this.newOrExistingOption == 1) {
        this.onCreateNewEquipmentClick();
      }
    }));
  }

  loadMakes() {
    this._loading.startLoading();
    this._subscriptions.push(this._equipmentService.getOEMMakeList().subscribe(r => {
      this.makeList = r;
      this.makeListFilter = r;
      this._loading.finishedLoading();
    }));
  }

  onMakeSelected(event: any) {
    const make = this.makeList.find(x => x.Name === event.value);
    if (make) {
      this.selectedMake = make.Id;
      this.makeName = make.Name;
    }
    this.loadModelsForMake();
  }

  changedMake(event: any) {
    const value = event.target.value;
    if (value !== '') {
      const filterValue = value.toLowerCase();
      this.makeList = this.makeListFilter.filter(x => x.Name.toLowerCase().includes(filterValue));
    } else {
      this.resetMake();
    }
  }

  resetMake() {
    this.makeName = '';
    this.selectedMake = 0;
    this.makeList = this.makeListFilter;
  }

  loadModelsForMake() {
    if (this.selectedMake == null)
      return;
    this._loading.startLoading();
    this.modelList = [];
    this.selectedModel = null;

    this.machineModel = '';
    this.familyName = '';
    this.selectedFamily = null;
    this._subscriptions.push(this._equipmentService.getModelList(this.selectedMake).subscribe(r => {
      this.modelList = r;
      this.modelListFilter = r;
      this._loading.finishedLoading();
    }));
  }

  loadFamilyNameForModel() {
    this._loading.startLoading();
    this._subscriptions.push(this._equipmentService.getFamilyNameForModel(this.selectedModel).subscribe((r:any) => {
      this.selectedFamily = r;
      this.familyName = this.selectedFamily.Name;
      console.log('this.selectedFamily.ShowPropelHrsPerc', this.selectedFamily.ShowPropelHrsPerc)
      //if(this.selectedFamily.Id==177 || this.selectedFamily.Id==203){
      if (this.selectedFamily.ShowPropelHrsPerc) {
        this.isRSH = true;
      } else {
        this.isRSH = false;
      }
      this.showDistTravelledTrackingForFamily(0, this.selectedModel);
      this._loading.finishedLoading();
    }));

  }

  showDistTravelledTrackingForFamily(equipmentId: number, selectedModel: number) {
    //this._loading.startLoading();
    console.log("equipmentId: " + equipmentId.toString());
    console.log("selectedModel: " + selectedModel.toString());
    this._subscriptions.push(this._equipmentService.showDistTravelledTrackingForFamily(equipmentId, selectedModel).subscribe(r => {
      this.showDistTravelledTracking = r;
    }));

  }

  // onSelectEquipmentPhoto(event) {
  //   if (event.target.files && event.target.files[0]) {
  //     var reader = new FileReader();

  //     reader.readAsDataURL(event.target.files[0]); // read file as data url

  //     reader.onload = (event: FileReaderEvent) => { // called once readAsDataURL is completed
  //       this.imageUrl = event.target.result;
  //     }

      
  //   }
  // }
  onSelectEquipmentPhoto(event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
  
      reader.readAsDataURL(event.target.files[0]); // Read file as data URL
  
      reader.onload = (event: ProgressEvent<FileReader>) => { // Called once readAsDataURL is completed
        if (event.target && event.target.result) {
          this.imageUrl = event.target.result as string; // Set image URL
        }
      };
    }
  }
  


  requestANewModelPopup() {
    const dialogRef = this._dialog.open(RequestNewModelPopupComponent, {
      panelClass: 'removeModalOverflow',
      data: {

      }
    });


  }

  modelTitle: string = "";
  model_auto_: number;

  machineModel: string = "";
  onSelcetionModel(event: any) {
    let id = this.modelList.find(f => f.Name == event.value).Id
    this.selectedModel = id;

    this.loadFamilyNameForModel();
  }
  changedModel(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this.modelList = this.modelList.filter(option => option.Name.toLowerCase().includes(filterValue));
    }
    else {
      this.resetModel();
    }
  }

  resetModel() {
    this.selectedModel = 0;
    this.modelList = this.modelListFilter;
  }


  translate(value: string): string {
    return this._translate.translateToLang(value, this._userLanguage);
  }

}

interface FileReaderEventTarget extends EventTarget {
  result: string
}

interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}
